(function() {
  function checkFormLoaded() {
    var formEmbed = document.querySelector('shopify-forms-embed');
    if (formEmbed && formEmbed.shadowRoot && formEmbed.shadowRoot.querySelector('form')) {
      document.body.classList.add('contact-ready');
      return true;
    }
    return false;
  }

  if (!checkFormLoaded()) {
    var observer = new MutationObserver(function() {
      if (checkFormLoaded()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function() {
      document.body.classList.add('contact-ready');
      observer.disconnect();
    }, 3000);
  }
})();
